import { HelpCircle } from 'lucide-react'
import { Tooltip } from '../../../../components/ui/Tooltip'
import { useScopeStore } from '../../store'
import { getFieldById, getGroupById, getSectionById } from '../../schema'
import { useUpsellContext } from '../../hooks/useUpsellContext'

export function AdvancedIdvSection() {
  const { scope, updateBiometricsConfig } = useScopeStore()
  const { biometricsConfig } = scope
  const { mapLabel } = useUpsellContext()
  const disabled = scope.finalized

  // --- IDV / Biometrics fields ---
  const platformSection = getSectionById('biometrics_platform')
  const platformGroup = getGroupById('biometrics_platform_group')
  const platformChoiceField = getFieldById('biometrics_platform_choice')

  return (
    <div className="border border-[var(--border-color)] rounded-lg p-4">
      <div className="flex items-center gap-2 mb-1">
        <h4 className="text-sm font-medium text-[var(--text-primary)]">
          {platformSection?.formTitle || platformGroup?.formTitle || 'Platform'}
        </h4>
        <Tooltip
          content={
            platformGroup?.tooltip ||
            platformChoiceField?.tooltip ||
            ''
          }
        >
          <HelpCircle size={14} className="text-[var(--text-muted)] hover:text-[var(--text-secondary)]" />
        </Tooltip>
      </div>
      {(platformGroup?.formDescription || platformChoiceField?.formDescription) && (
        <p className="text-xs text-[var(--text-muted)] mt-1 mb-3">
          {platformGroup?.formDescription || platformChoiceField?.formDescription}
        </p>
      )}
      <div className="flex gap-4">
        {(
          (platformChoiceField?.options || [
            { value: 'web', label: 'Web-based' },
            { value: 'in_app', label: 'In-App (SDK)' },
            { value: 'both', label: 'Both' },
            { value: 'unknown', label: mapLabel("Don't know") },
          ]) as Array<{ value: string; label: string }>
        ).map((opt) => (
          <label key={opt.value} className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="platform"
              className="w-4 h-4 text-primary focus:ring-primary"
              checked={biometricsConfig.platform === (opt.value as any)}
              onChange={() => updateBiometricsConfig('platform', opt.value as any)}
              disabled={disabled}
            />
            <span className="text-sm text-[var(--text-primary)]">{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  )
}
